export default "__VITE_ASSET__DX97PZIH__"